import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum EvacuationZoneEnum {
    ZoneA = 1,
    ZoneB = 2,
    ZoneC = 3,
    ZoneD = 4,
    ZoneE = 5,
    ZoneNE = 6,
    ZoneSN = 7
}
class EvacuationZoneClass extends EnumWithDescription<EvacuationZoneEnum> {
    public readonly enum = EvacuationZoneEnum;
    public readonly enumName: string = "EvacuationZoneEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<EvacuationZoneEnum>> = new Map([
        [
            "ZoneA",
            {
                value: EvacuationZoneEnum.ZoneA,
                name: "Zone A"
            }
        ],
        [
            "ZoneB",
            {
                value: EvacuationZoneEnum.ZoneB,
                name: "Zone B"
            }
        ],
        [
            "ZoneC",
            {
                value: EvacuationZoneEnum.ZoneC,
                name: "Zone C"
            }
        ],
        [
            "ZoneD",
            {
                value: EvacuationZoneEnum.ZoneD,
                name: "Zone D"
            }
        ],
        [
            "ZoneE",
            {
                value: EvacuationZoneEnum.ZoneE,
                name: "Zone E"
            }
        ],
        [
            "ZoneNE",
            {
                value: EvacuationZoneEnum.ZoneNE,
                name: "Zone NE"
            }
        ],
        [
            "ZoneSN",
            {
                value: EvacuationZoneEnum.ZoneSN,
                name: "Zone SN"
            }
        ]
    ]);
}

export const EvacuationZone = new EvacuationZoneClass();
